<mat-card>
  <mat-card-content>
    <app-terms-display
      [termsLabel]="'Terms'"
      [header]="'PAD terms'"
      [message]="'You have a USD bank account linked to your TUIO account'"
      [agreeLabel]="'I agree to the pre-authorize debit terms above'"
      [contentWidgetTag]="ContentWidgetTag.PadTermsUsa"
      [effectiveDateSetting]="Setting.PadTermsUsaDate"
      (submitted)="submit()">
    </app-terms-display>
  </mat-card-content>
</mat-card>